var Marionette = require('marionette');
var Entities = require('Entities');
var Filter = require('QuestionnairesFilter');
var Grid = require('Grid');
var Pagination = require('Pagination');
var Labels = EY.Consultation.Labels;
var Geographies = new Entities.Geographies(EY.Consultation.Resources.Geography);
var User = EY.Consultation.CurrentUser;

var Layout = Marionette.View.extend({
    regions: {
        filter: '#filter',
        grid: '#questionnairesGrid',
        pager: '#pager'
    },
    template: '#questionnaires'
});

var Edit = Marionette.View.extend({
    className: 'string-cell sortable renderable id',
    events: {
        'click @ui.id': 'navigate'
    },
    tagName: 'td',
    template: '#questionnaireGridAction',
    ui: {
        id: '#id'
    },
    navigate: function () {
        Router.navigate('Questionnaire/' + this.model.id, { trigger: true });
    }
});

var columns = function () {
    return [{ name: 'area', label: Labels.Area, editable: false, cell: 'string' },
    { name: 'region', label: Labels.Region, editable: false, cell: 'string' },
    { name: 'country', label: Labels.Country, editable: false, cell: 'string' },
    { name: 'recordType', label: Labels.RecordType, editable: false, cell: 'string' },
    { name: '', label: '', editable: false, cell: Edit }];
};

module.exports.start = function () {
    var consultation = require('Consultation');
    var queries = new Entities.Queries([{ id: 'default', filter: { geographyId: { $regex: User.adminGeography } }, select: { geographyId: 1, recordTypeId: 1 }, selected: true }]);
    var questionnaires = new Entities.Questionnaires();
    var layout = new Layout();

    consultation.show({ view: layout });
    Grid.show({
        collection: questionnaires,
        columns: columns(),
        region: layout.getRegion('grid')
    });
    Pagination.show({ queries: queries, rows: questionnaires, region: layout.getRegion('pager') });
    Filter.show({ queries: queries, rows: questionnaires, region: layout.getRegion('filter') });

    questionnaires.on('sync', function () {
        questionnaires.each(function (questionnaire) {
            var country = Geographies.get(questionnaire.get('geographyId'));
            var region = Geographies.get(country.get('parentId'));
            var area = Geographies.get(region.get('parentId')); 

            questionnaire.set({
                country: country.get('text'),
                region: region.get('text'),
                area: area.get('text'),
                recordType: Labels[questionnaire.get('recordTypeId')]
            });
        });
        questionnaires.sortBy('area');
    });
};



// WEBPACK FOOTER //
// ./js/Modules/Questionnaire/Questionnaires.js